module.exports = __webpack_public_path__ + "img/2-6398.699b0d14.png";